import axios from "axios";
import request from "../infra/request";
import firebase from "./firebase";

const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

export const uploadClientFile = async ({ fileId, clientId, source }) => {
  if (!fileId || !clientId) {
    return { error: new Error('"fileId" and "clientId" can not be empty') };
  }
  try {
    const user = firebase.currentUser();
    const token = user && (await user.getIdToken());
    const response = await axios.post(
      `${process.env.REACT_APP_CLIENT_FILE}`,
      {
        fileId,
        clientId,
        source,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};

export const uploadErrorFileToCoreplus = async ({
  fileId,
  clientId,
  specialistId,
  fromReferralInbox,
  aiOcr,
  fileName,
}) => {
  if (!fileId) {
    return { error: new Error('"fileId" can not be empty') };
  }
  try {
    let response;
    if (isDataFromPMS) {
      response = await request.post("/pms/admin/error-file", {
        medicalResultId: fileId,
        clientId,
        specialistId,
        fromReferralInbox,
        fileName,
      });
    } else {
      response = await request.post("/admin/coreplus/error-file", {
        fileId,
        clientId,
        specialistId,
        fromReferralInbox,
        aiOcr,
      });
    }
    return { data: response.data };
  } catch (error) {
    return { error };
  }
};
